import { COMPENSATION_COMPLIANCE_ACTION_TYPE } from '../actions';

const initialState = null;

const compensationComplianceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPENSATION_COMPLIANCE_ACTION_TYPE.GET_CONFIG:
    case COMPENSATION_COMPLIANCE_ACTION_TYPE.UPDATE_CONFIG:
      return payload || initialState;

    default:
      return state;
  }
};

export default compensationComplianceReducer;
